export class Pagination {
	static readonly defaultMaxPagesPerChunk = 5;
	static readonly defaultPagesChunk = 1;
	static readonly defaultPage = 1;
	static readonly defaultItemsPerPage = 10;

	protected constructor() {
	}

	static initCurrentPage(): number {
		return Pagination.defaultPage;
	}

	static paginateCollection<T>(collection: T[], start = 0, end = 10): T[] {
		return collection.filter((item, index) => {
			return index >= start && index < end;
		});
	}

	static calculateNumberOfPages(itemsPerPage: number, totalItems: number): number {
		let numberOfPages = Math.floor(totalItems / itemsPerPage);

		if (totalItems % itemsPerPage) {
			numberOfPages += 1;
		}

		return numberOfPages;
	}

	static calculateMaxPageNumber(pagesChunk: number): number {
		return Pagination.defaultMaxPagesPerChunk * pagesChunk;
	}

	static calculateMinPageNumber(maxPageNumber: number): number {
		return maxPageNumber - Pagination.defaultMaxPagesPerChunk;
	}

	static createPagesRange(min: number, max: number): number[] {
		const pagesRange = [];

		for (let i = max; i > min; i--) {
			pagesRange.push(i);
		}

		return pagesRange.reverse();
	}

	static calculatePageWhenPreviousClicked(currentPage: number): number {
		return currentPage - 1;
	}

	static calculateMinPageNumberWhenPreviousClicked(pagesChunk: number): number {
		return (Pagination.defaultMaxPagesPerChunk * pagesChunk) - Pagination.defaultMaxPagesPerChunk;
	}

	static calculateChunkWhenPreviousClicked(pagesChunk: number): number {
		return pagesChunk - 1;
	}

	static calculateStartPagesChunkIndex(page: number, itemsPerPage: number, pagesChunk: number): number {
		return ((page - 1) - ((pagesChunk - 1) * Pagination.defaultMaxPagesPerChunk)) * itemsPerPage;
	}

	static calculateEndPagesChunkIndex(page: number, itemsPerPage: number, pagesChunk: number): number {
		return (page - ((pagesChunk - 1) * Pagination.defaultMaxPagesPerChunk)) * itemsPerPage;
	}

	static calculatePageWhenPagesChunkChanged(direction: boolean, pagesChunk: number): number {
		if (!direction) {
			return (pagesChunk - 1) * Pagination.defaultMaxPagesPerChunk;
		}

		return (pagesChunk * Pagination.defaultMaxPagesPerChunk) + 1;
	}

	static calculateStartIndexWhenPagesChunkChanged(direction: boolean, itemsPerPage: number): number {
		if (!direction) {
			return (Pagination.defaultMaxPagesPerChunk - 1) * itemsPerPage;
		}

		return 0;
	}

	static calculateEndIndexWhenPagesChunkChanged(direction: boolean, itemsPerPage: number): number {
		if (!direction) {
			return Pagination.defaultMaxPagesPerChunk * itemsPerPage;
		}

		return itemsPerPage;
	}

	static calculatePageWhenNextClicked(currentPage: number): number {
		return currentPage + 1;
	}

	static calculateMaxPageNumberWhenNextClicked(pagesChunk: number): number {
		return Pagination.defaultMaxPagesPerChunk * pagesChunk;
	}

	static calculateChunkWhenNextClicked(pagesChunk: number): number {
		return pagesChunk + 1;
	}

	static calculateItemsPerPagesChunk(itemsPerPage = Pagination.defaultItemsPerPage): number {
		const itemsPerChunk = (Pagination.defaultMaxPagesPerChunk * itemsPerPage);

		/**
		 * Append more item to the chunk for check about next chunk.
		 */
		return itemsPerChunk + Pagination.defaultItemsPerPage;
	}

	static calculateItemsPerPage(pageChunkSize: number): number {
		return (pageChunkSize - Pagination.defaultItemsPerPage) / Pagination.defaultMaxPagesPerChunk;
	}
}
